<section>

  @for (blog of this.blogs; track blog; let i = $index) {
    <article>
      <img src="{{blog.featuredImage}}" class="blog-image" />
      <div class="content">
        <div class="inner-content" overflowShadow>
          <div class="date">{{blog.publishDate | date:'MM/dd/y'}}</div>
          <h1>{{blog.name}}</h1>
          <summary [innerHTML]="blog.postSummary"></summary>
      </div>
      <div class="button-container">
        <a [href]="blog.url" target="_blank">READ MORE ON THE SOFTPRO BLOG</a>
      </div>
    </div>
  </article>
}

</section>







